import React from 'react';
import { CalendarClock } from 'lucide-react';
import ModalShell from './ModalShell';
import ProductionForecastCard from './ProductionForecastCard';

export default function ProductionForecastModal({ open, onClose, orderId, refreshKey }) {
  return (
    <ModalShell
      open={open}
      onClose={onClose}
      variant="window"
      panelClassName="sm:max-w-sm max-h-[calc(100dvh-2rem)] overflow-y-auto"
      panelProps={{ role: 'dialog', 'aria-modal': true, 'aria-labelledby': 'production-forecast-title' }}
    >
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-indigo-100 text-indigo-700 dark:bg-indigo-950/60 dark:text-indigo-300">
          <CalendarClock className="h-4.5 w-4.5" />
        </span>
        <h2 id="production-forecast-title" className="text-base font-semibold text-gray-900 dark:text-gray-100">
          Ориентировочные сроки
        </h2>
      </div>

      <div className="mt-4">
        <ProductionForecastCard
          orderId={orderId}
          refreshKey={refreshKey}
          showHeading={false}
        />
      </div>

      <button
        type="button"
        onClick={onClose}
        className="mt-4 w-full rounded-xl bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:focus:ring-offset-gray-900"
      >
        Понятно
      </button>
    </ModalShell>
  );
}
